// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3d764af","732":"c5e0c685","977":"fc10f4d9"}[chunkId] + ".chunk.js";
};